import React from "react";
import { Link } from "react-router-dom";
import useCartStore from "../store/shoppingCardStore";
import { ShoppingCart, Plus, Minus, Battery } from "lucide-react";
import styles from "../styles/Cards.module.css";
import Product1 from "../images/products/battrey-varian.jpg";
import p11 from "../images/products/p1.1.jpg";
import p12 from "../images/products/p1.2.jpg";
import p13 from "../images/products/p1.3.jpg";
import p14 from "../images/products/p1.4.jpg";
import p21 from "../images/products/p2.1.jpg";
import p22 from "../images/products/p2.2.jpg";
import p31 from "../images/products/p3.1.jpg";
import p32 from "../images/products/p3.2.jpg";
import p33 from "../images/products/p3.3.jpg";
import p41 from "../images/products/p4.1.jpg";
import p42 from "../images/products/p4.2.jpg";
import { slugify } from "../utils/utils"; // Import slugify

const products = [
  {
    name: "باتری واریان صبا 50 آمپر ال1(Varian 50 L1)",
    slug: "battery-50ah-saba-varian-l1",
    image: [p11, p12, p13, p14],
    info: `
    <h2>خرید و قیمت باتری 50 آمپر صبا واریان L1</h2>
    <p>باتری خودرو 50 آمپر واریان L1 تولید شرکت صبا باتری، یکی از باکیفیت‌ترین محصولات در رده باتری‌های اتمی سیلد است. این مدل با طراحی پیشرفته و تکنولوژی روز، گزینه‌ای ایده‌آل برای خودروهای شهری و سبک محسوب می‌شود.</p>

    <h3>چرا باتری واریان 50 آمپر را انتخاب کنیم؟</h3>
    <p>مدل L1 باتری واریان با آمپر 50 و ولتاژ 12، محصولی کاملاً بهینه برای استفاده در شرایط مختلف جاده‌ای است. از مهم‌ترین مزایای این محصول می‌توان به موارد زیر اشاره کرد:</p>
    
    <ul>
      <li>طراحی اتمی سیلد (بدون نیاز به نگهداری و افزودن آب مقطر)</li>
      <li>مقاومت استثنایی در برابر لرزش‌های مداوم خودرو</li>
      <li>عملکرد عالی در دمای پایین (استارت‌زنی قوی در هوای سرد)</li>
      <li>سیستم فیلتراسیون ضد انفجار برای ایمنی بیشتر</li>
      <li>طول عمر بالا و دوام قابل توجه</li>
    </ul>

    <h3>مشخصات فنی باتری 50 آمپر</h3>
    <p>این مدل از باتری خودرو با ابعاد 207×175×190 میلی‌متر و وزن 12.7 کیلوگرم، به‌راحتی در محفظه باتری خودروهای سبک جای می‌گیرد. گارانتی 12 ماهه شرکت صبا باتری، نشان‌دهنده اعتماد سازنده به کیفیت این محصول است.</p>

    <p>باتری واریان 50 آمپر برای خودروهای تیبا، پراید، پژو 206، پژو 207، رانا، هایوندای i20، کوییک و ساینا انتخاب مناسبی است. قیمت این محصول با توجه به کیفیت ساخت و خدمات پس از فروش، کاملاً اقتصادی و مقرون‌به‌صرفه می‌باشد.</p>

    <p>برای خرید باتری 50 آمپر اصل با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه کنید. کارشناسان ما آماده ارائه مشاوره تخصصی برای انتخاب بهترین باتری متناسب با نیاز خودروی شما هستند.</p>
  `,
    price: 2375000,
    infos: `
    <ul>
      <li><strong>نوع:</strong> اتمی سیلد (MF)</li>
      <li><strong>آمپر ساعت:</strong> 50Ah</li>
      <li><strong>ولتاژ:</strong> 12 ولت</li>
      <li><strong>ابعاد:</strong> 207×175×190 میلی‌متر</li>
      <li><strong>وزن:</strong> 12.7 کیلوگرم</li>
      <li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
      <li><strong>سازنده:</strong> شرکت صبا باتری</li>
    </ul>
  `,
    id: 6,
    meta: {
      title: "خرید باتری 50 آمپر واریان L1 | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 50 آمپر صبا واریان L1 با گارانتی 12 ماهه، مناسب خودروهای شهری و سبک. قیمت روز و مشخصات فنی کامل.",
      keywords: "باتری 50 آمپر, قیمت باتری واریان, باتری صبا, باتری خودرو",
    },
  },
  {
    name: "باتری واریان صبا 50 آمپر ال2(Varian 50 L1)",
    slug: "battery-50ah-saba-varian-l2",
    image: [p21, p22],
    info: `<h2>خرید و قیمت باتری 50 آمپر صبا واریان L2</h2>
<p>باتری خودرو 50 آمپر واریان L2 از تولیدات باکیفیت شرکت صبا باتری است که با قیمت مناسب و گارانتی 12 ماهه عرضه می‌شود. این محصول با تکنولوژی روز دنیا تولید شده و گزینه‌ای ایده‌آل برای خودروهای سبک شهری محسوب می‌شود.</p>

<h3>مزایای کلیدی باتری واریان L2</h3>
<p>مدل L2 باتری واریان با آمپر 50 و ولتاژ 12 ولت، محصولی کارآمد برای استفاده در شرایط مختلف رانندگی است. مهم‌ترین ویژگی‌های این محصول عبارتند از:</p>

<ul>
  <li>طراحی اتمی سیلد بدون نیاز به نگهداری</li>
  <li>مقاومت فوق‌العاده در برابر لرزش و ضربه</li>
  <li>عملکرد مطلوب در دمای پایین (استارت‌زنی سریع در هوای سرد)</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر طولانی و بازدهی بالا</li>
</ul>

<h3>ویژگی‌های فنی محصول</h3>
<p>این مدل باتری با ابعاد 242×175×190 میلی‌متر و وزن 13.8 کیلوگرم، به‌راحتی در محفظه باتری خودروهای سبک نصب می‌شود. گارانتی 12 ماهه شرکت صبا باتری نشانه اطمینان از کیفیت ساخت این محصول است.</p>

<p>باتری واریان 50 آمپر L2 برای خودروهای تیبا، پراید، پژو 206، پژو 207، رانا، هایوندای i20، کوییک و ساینا مناسب است. قیمت این محصول با در نظر گرفتن کیفیت و خدمات پس از فروش، کاملاً اقتصادی و به صرفه می‌باشد.</p>

<p>برای خرید باتری 50 آمپر واریان L2 با گارانتی معتبر، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه راهنمایی تخصصی برای انتخاب بهترین باتری متناسب با خودروی شما هستند.</p>`,
    price: 2380000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (MF)</li>
<li><strong>آمپر ساعت:</strong> 50Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 242×175×190 میلی‌متر</li>
<li><strong>وزن:</strong> 13.8 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری</li>
</ul>`,
    id: 7,
    meta: {
      title: "خرید باتری 50 آمپر واریان L2 | قیمت ویژه با گارانتی | باتری۱۰۰",
      description:
        "باتری 50 آمپر واریان L2 با طراحی اتمی سیلد، گارانتی 12 ماهه و قیمت مناسب برای خودروهای سبک شهری. مناسب پژو 206 و 207.",
      keywords:
        "باتری 50 آمپر, باتری واریان L2, باتری پژو 206, قیمت باتری خودرو, باتری اتمی",
    },
  },
  {
    name: "باتری واریان صبا 55 آمپر (Varian 55) ",
    slug: "battery-55ah-saba-varian",

    image: [p31, p32, p33],
    info: `<h2>خرید و قیمت باتری 55 آمپر صبا واریان L2</h2>
<p>باتری خودرو 55 آمپر واریان L2 از تولیدات باکیفیت شرکت صبا باتری است که با طراحی اتمی سیلد و گارانتی 12 ماهه عرضه می‌شود. این محصول با ابعاد بهینه و وزن مناسب، گزینه‌ای ایده‌آل برای خودروهای پراید، پژو 206، تیبا و هیوندای ورنا می‌باشد.</p>

<h3>ویژگی‌های منحصر به فرد</h3>
<p>باتری واریان 55 آمپر L2 با تکنولوژی پیشرفته تولید شده و مزایای زیر را ارائه می‌دهد:</p>

<ul>
  <li>طراحی سیلد (خشک) بدون نیاز به نگهداری</li>
  <li>مقاومت استثنایی در برابر لرزش و ضربات جاده‌ای</li>
  <li>عملکرد عالی در دمای پایین (استارت‌زنی سریع تا -30 درجه)</li>
  <li>سیستم ایمنی پیشرفته با فیلتر ضد انفجار</li>
  <li>عمر طولانی با حداقل افت شارژ در حالت سکون</li>
</ul>

<h3>مشخصات فنی</h3>
<p>این مدل باتری با ابعاد 240×175×190 میلی‌متر و وزن 16.5 کیلوگرم، به‌راحتی در محفظه باتری خودروهای سبک نصب می‌شود. ولتاژ 12 ولت و آمپر 55Ah این محصول، نیاز خودروهای شهری را به‌طور کامل برطرف می‌کند.</p>

<p>قیمت باتری 55 آمپر صبا با توجه به کیفیت ساخت و خدمات پس از فروش، کاملاً اقتصادی بوده و با خرید از باتری۱۰۰ از نصب رایگان و خدمات امداد خودرو در تهران بهره‌مند خواهید شد.</p>

<h3>تأثیر دما بر عملکرد باتری</h3>
<p>باتری واریان 55 آمپر برای عملکرد در شرایط آب‌وهوایی مختلف طراحی شده است. در دمای پایین، سیستم شیمیایی بهینه‌شده آن امکان استارت‌زنی سریع را فراهم می‌کند. در دمای بالا نیز با استفاده از مواد مقاوم، از تبخیر الکترولیت جلوگیری می‌کند.</p>

<p>برای افزایش عمر باتری توصیه می‌شود:</p>
<ul>
  <li>پایانه‌ها را ماهانه تمیز کنید</li>
  <li>از خالی ماندن طولانی‌مدت باتری جلوگیری کنید</li>
  <li>در صورت عدم استفاده طولانی، باتری را شارژ نگه دارید</li>
</ul>`,
    price: 2650000,
    infos: `<ul>
<li><strong>نوع:</strong> اتمی سیلد (خشک)</li>
<li><strong>آمپر ساعت:</strong> 55Ah</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> 240×175×190 میلی‌متر</li>
<li><strong>وزن:</strong> 16.5 کیلوگرم</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت رسمی</li>
<li><strong>سازنده:</strong> شرکت صبا باتری </li>
<li><strong>خودروهای سازگار:</strong> پراید، پژو 206، تیبا، هیوندای ورنا</li>
</ul>`,
    id: 8,
    meta: {
      title: "باتری 55 آمپر واریان | قیمت روز با گارانتی معتبر | باتری۱۰۰",
      description:
        "باتری 55 آمپر واریان با قدرت استارت‌زنی بالا، مناسب خودروهای پراید، تیبا، پژو 206 و هیوندای ورنا. گارانتی 12 ماهه صبا باتری.",
      keywords:
        "باتری 55 آمپر, باتری پراید, باتری تیبا, قیمت باتری واریان, باتری اتمی سیلد",
    },
  },
  {
    name: " باتری واریان صبا 60 آمپر پایه کوتاه (Varian 60) ",
    slug: "battery-60ah-saba-varian-short",
    image: [p41, p42],
    info: `<h2>خرید و قیمت باتری 60 آمپر واریان کوتاه</h2>
<p>باتری خودرو 60 آمپر واریان کوتاه از تولیدات با کیفیت شرکت سپاهان باتری است که با طراحی ویژه برای خودروهای سبک تولید شده است. این محصول با قیمت مناسب و گارانتی معتبر، انتخاب بسیاری از رانندگان آگاه می‌باشد.</p>

<h3>مزایای باتری واریان 60 آمپر کوتاه</h3>
<p>این مدل باتری با تکنولوژی روز و مواد اولیه مرغوب تولید شده و دارای ویژگی‌های منحصر به فردی است:</p>

<ul>
  <li>طراحی کوتاه و مناسب برای خودروهای سبک</li>
  <li>استارت‌زنی قوی حتی در دمای پایین</li>
  <li>مقاومت بالا در برابر لرزش و ضربه</li>
  <li>عمر طولانی و عملکرد پایدار</li>
  <li>سیستم ایمنی پیشرفته</li>
  <li>قیمت مناسب نسبت به نمونه‌های خارجی</li>
</ul>

<h3>مشخصات فنی</h3>
<p>باتری واریان 60 آمپر کوتاه با ابعاد استاندارد و وزن مناسب طراحی شده است:</p>

<ul>
  <li><strong>نوع:</strong> اسیدی-سربی</li>
  <li><strong>ظرفیت:</strong> 60 آمپر ساعت</li>
  <li><strong>ولتاژ:</strong> 12 ولت</li>
  <li><strong>ابعاد:</strong> استاندارد کوتاه</li>
  <li><strong>گارانتی:</strong> معتبر شرکتی</li>
</ul>

<h3>خودروهای سازگار</h3>
<p>این مدل باتری برای خودروهای زیر مناسب است:</p>
<ul>
  <li>پژو 206 و 405</li>
  <li>سمند و سمند LX</li>
  <li>پراید و تیبا</li>
  <li>رانا و ال 90 (لوگان)</li>
</ul>

<h3>نکات مهم خرید</h3>
<p>برای خرید باتری واریان 60 آمپر کوتاه به این موارد توجه کنید:</p>
<ul>
  <li>تاریخ تولید جدید</li>
  <li>گارانتی معتبر</li>
  <li>فروشگاه‌های معتبر</li>
  <li>مقایسه قیمت</li>
</ul>

<p>برای اطلاع از قیمت دقیق و خرید مطمئن باتری واریان 60 آمپر کوتاه، می‌توانید به باتری۱۰۰ مراجعه نمایید. کارشناسان ما آماده ارائه مشاوره رایگان هستند.</p>`,
    price: 2800000,
    infos: `<ul>
<li><strong>برند:</strong> واریان (شرکت سپاهان باتری)</li>
<li><strong>نوع:</strong> اسیدی-سربی</li>
<li><strong>ظرفیت:</strong> 60 آمپر ساعت</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ابعاد:</strong> استاندارد کوتاه</li>
<li><strong>گارانتی:</strong> معتبر شرکتی</li>
<li><strong>ویژگی‌ها:</strong> مقاوم در برابر لرزش، عملکرد عالی در دمای پایین</li>
</ul>`,
    id: 9,
    meta: {
      title: "خرید باتری 60 آمپر واریان کوتاه | قیمت با تخفیف ویژه | باتری۱۰۰",
      description:
        "باتری 60 آمپر واریان کوتاه با طراحی فشرده، مناسب خودروهای پژو 405، سمند و رانا. گارانتی 12 ماهه و قیمت رقابتی.",
      keywords:
        "باتری 60 آمپر, باتری کوتاه, باتری پژو 405, باتری سمند, قیمت باتری خودرو",
    },
  },
];

const Cards = () => {
  const { items, itemscount, addItem, removeItem } = useCartStore();
  const nameitem = items.map((item) => item.name);

  // تابع برای بررسی موجود بودن محصول
  const isProductAvailable = (productName) => {
    return !productName.includes("(ناموجود)");
  };

  return (
    <div className={styles.cardsContainer}>
      <div className={styles.header}>
        <Battery className={styles.headerIcon} size={28} />
        <h2>محصولات باتری خودرو</h2>
        <p>با کیفیت ترین باتری ها با گارانتی معتبر</p>
        <Link
          to={{
            pathname: "/محصولات/",
            state: { defaultFilter: "car" },
          }}
          className={styles.viewAllBtn}
        >
          نمایش تمام محصولات باتری خودرو
        </Link>
      </div>

      <div className={styles.productsGrid}>
        {products.map((product) => (
          <div key={product.id} className={styles.productCard}>
            <Link
              to={`/product/${slugify(product.name)}`}
              className={styles.productImageLink}
            >
              <img
                src={product.image[0]}
                alt={product.name}
                className={styles.productImage}
                loading="lazy"
              />
              <div className={styles.productOverlay}>
                <span>مشاهده جزئیات</span>
              </div>
            </Link>

            <div className={styles.productInfo}>
              <h3 className={styles.productTitle}>
                {product.name}
                <span className={styles.productCategory}>باتری - خودرو</span>
              </h3>

              <p className={styles.productPrice}>
                <span className={styles.priceLabel}>قیمت: </span>
                {product.price.toLocaleString()} تومان
              </p>

              {/* تغییر در این بخش */}
              {!isProductAvailable(product.name) ? (
                <div className={styles.outOfStock}>ناموجود</div>
              ) : nameitem.includes(product.name) ? (
                <div className={styles.quantityControl}>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      removeItem(product.id);
                    }}
                    className={styles.quantityBtn}
                    aria-label="کاهش تعداد"
                  >
                    <Minus size={16} />
                  </button>
                  <span className={styles.quantityCount}>
                    {itemscount[product.id] || 0}
                  </span>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      addItem(product);
                    }}
                    className={styles.quantityBtn}
                    aria-label="افزایش تعداد"
                  >
                    <Plus size={16} />
                  </button>
                </div>
              ) : (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    addItem(product);
                  }}
                  className={styles.addToCartBtn}
                >
                  <ShoppingCart size={18} />
                  افزودن به سبد خرید
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cards;
